exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#contact-page-container{width:80%}@media(max-width: 576px){#contact-page-container{width:95%;max-width:100%;padding:0 8px}}.brand-center{text-align:center}#my-contact-card-modal{max-width:800px}@media(min-width: 577px){#contact-page-container{max-width:80%}}@media(min-width: 900px){#contact-page-container{max-width:800px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/pages/ContactCardPage/styles.scss
// module id = 945
// module chunks = 0